import React from "react";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import { Row, Col } from "antd";
import { FormField, IButton } from "../../../../ui-kit";
import defectCardsStore from "../../../../store/defectCards";
import { useHandleForm } from "../../../../hooks/useHandleForm";
import { useStatusMessage } from "../../../../hooks/useStatusMessage";
import styles from "./DefectReject.module.scss";

const DefectReject: React.FC<{
  data: any;
  onClose: () => void;
  targetKey: string;
}> = observer(({ data, onClose, targetKey }) => {
  const { defectRejectStatus, defectRejectFormIsSending } = defectCardsStore;
  const initialValues = {
    message: null,
  };
  const initialFocus = {};
  const { register, handleSubmit, watchAllField } = useHandleForm(
    null,
    initialValues,
    initialFocus,
  );

  useStatusMessage(defectRejectStatus);

  const onSubmit = (values) => {
    const request = {
      ids: [data.id],
      isValid: !data.isValid,
    };
    //defectCardsStore.sendDefectAgreed(data.id, request);
    defectCardsStore.sendDefectRejection(data.id, values);
    //defectCardsStore.removeCard(targetKey);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles.defectReject}>
      <Row>
        <Col span={24}>
          <FormField
            className={styles.defectRejectField}
            register={register}
            label="Укажите причину отклонения"
            name="message"
            type="textarea"
            currentValue={watchAllField.message}
          />
        </Col>
      </Row>
      <Row className={styles.defectRejectButtonWrapper}>
        <Col span={12} className={styles.defectRejectButton}>
          <IButton disabled={defectRejectFormIsSending.value}>
            Отклонить
          </IButton>
        </Col>
        <Col span={12} className={styles.defectRejectButton}>
          <IButton onClick={onClose} variant="outlined" type="button">
            Отмена
          </IButton>
        </Col>
      </Row>
    </form>
  );
});

export default DefectReject;
